import * as AppConstants from 'app/AppConstants';

export const offsetViewport = offsets => ({
  type: AppConstants.VIEWPORT__CHANGED,
  payload: {
    offsets,
  },
});
